(function () {
  'use strict';

  var root = document.querySelector('[data-ceika-support]');
  if (window.CeikaSupportChatBound) return;
  window.CeikaSupportChatBound = true;

  var helpTemplate = document.querySelector('template[data-ceika-product-chat-help]');
  var summary = document.querySelector('.ceika-build-rail__card, .coil-summary-rail .coil-order');
  if (helpTemplate && summary && !summary.querySelector('[data-ceika-chat-open]')) {
    summary.appendChild(helpTemplate.content.cloneNode(true));
  }

  var pending = false;
  var timeoutMs = 6000;

  var activeStatus;

  function status(message) {
    var node = activeStatus || (root && root.querySelector('[data-ceika-chat-status]'));
    if (node) node.textContent = message || '';
    return node;
  }

  function initializeWithTimeout() {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var listening = false;
      function removeLoadListener() {
        if (!listening) return;
        window.removeEventListener('gorgias-widget-loaded', init);
        listening = false;
      }
      var timer = window.setTimeout(function () {
        settled = true;
        removeLoadListener();
        reject(new Error('Chat unavailable'));
      }, timeoutMs);
      function finish(fn, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        removeLoadListener();
        fn(value);
      }
      function init() {
        if (settled) return;
        var chat = window.GorgiasChat;
        if (!chat || typeof chat.init !== 'function') {
          finish(reject, new Error('Chat unavailable'));
          return;
        }
        Promise.resolve().then(function () { return chat.init(); }).then(function () {
          finish(resolve, chat);
        }, function (error) { finish(reject, error); });
      }

      if (window.GorgiasChat) {
        init();
      } else {
        listening = true;
        window.addEventListener('gorgias-widget-loaded', init, { once: true });
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-ceika-chat-open], .ceika-option-help a, a.ceika-option-help')
      : null;
    if (!target) return;
    event.preventDefault();
    if (pending) return;

    pending = true;
    target.setAttribute('aria-busy', 'true');
    status('');
    var area = target.closest && target.closest('[data-ceika-chat-area]');
    var statusNode = area && area.querySelector('[data-ceika-chat-status]') || (root && root.querySelector('[data-ceika-chat-status]'));
    activeStatus = statusNode;
    status(statusNode && statusNode.getAttribute('data-loading') || 'Opening chat…');

    initializeWithTimeout().then(function (chat) {
      if (typeof chat.open !== 'function') throw new Error('Chat unavailable');
      var context = target.getAttribute('data-ceika-chat-context');
      if (!context && target.href) {
        var product = new URL(target.href, window.location.href).searchParams.get('product');
        if (product) context = product + '\n' + window.location.href;
      }
      return Promise.resolve(chat.open()).then(function () {
        if (context && typeof chat.setCurrentInput === 'function') chat.setCurrentInput(context);
      });
    }).then(function () {
      status('');
    }).catch(function () {
      status(statusNode && statusNode.getAttribute('data-unavailable') || 'Chat is unavailable. Please use the contact form below.');
      if (target.tagName === 'A' && target.getAttribute('href')) {
        var fallback = new URL(target.href, window.location.href);
        if (fallback.origin === window.location.origin && fallback.pathname === window.location.pathname && fallback.hash === '#ceika-contact-form') {
          var form = document.querySelector('#ceika-contact-form');
          if (form) form.scrollIntoView({ block: 'start' });
        } else if (fallback.origin === window.location.origin && /(?:^|\/)pages\/contact$/.test(fallback.pathname)) window.location.assign(fallback.href);
      }
    }).then(function () {
      pending = false;
      target.removeAttribute('aria-busy');
    });
  });
}());
